"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import { Month } from "react-day-picker";
import { getHolidaysInMonth } from "../helpers/holidays.js";
import { DayMapContext } from "../Providers/DayMapProvider.js";
import { HolidayList } from "./HolidayList.js";
function CustomMonth(props) {
    const dayMapContext = useContext(DayMapContext);
    const holidaysInMonth = useMemo(()=>getHolidaysInMonth(dayMapContext?.holidays, props.calendarMonth.date), [
        dayMapContext?.holidays,
        props.calendarMonth.date
    ]);
    return /*#__PURE__*/ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ jsx(Month, {
                ...props
            }),
            /*#__PURE__*/ jsx(HolidayList, {
                holidays: holidaysInMonth,
                slots: {
                    holidayRoot: 'my-1'
                }
            })
        ]
    });
}
export { CustomMonth };
